import { render } from "./ArticlesPage.vue?vue&type=template&id=76c018dd&scoped=true"
import script from "./ArticlesPage.vue?vue&type=script&lang=js"
export * from "./ArticlesPage.vue?vue&type=script&lang=js"

import "./ArticlesPage.vue?vue&type=style&index=0&id=76c018dd&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76c018dd"]])

export default __exports__